module.exports = __webpack_public_path__ + "static/media/color.fcfdc5c2.jpg";